<template>
  <div>
    <div class="document">
      <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;"> -->
      <h3 style="text-align: center;">Background Check</h3>
      <p style="text-align: center;">By filling out this form you are giving Coast to Coast Nannies and Sterling Background Check company the rights to run a background check.</p>
      <hr>
      <div class="field-of-fields">
        <div style="margin-top: -10px;" v-if="document.status == 'Unsigned'">
          <label style="margin-top: 10px;">First and Last Name*</label>
          <input type="text" class="form-control" v-model="field1">
          <label style="">Date of Birth (YYYY-MM-DD)*</label>
          <input type="text" class="form-control" v-model="field2">
          <label style="">Address*</label>
          <input type="text" class="form-control" v-model="field3" placeholder="Street Address">
          <!-- <label style="margin-top: 10px;">Parent's Name</label> -->
          <input type="text" class="form-control mt-1" v-model="field4" placeholder="Address Line 2">
          <!-- <label style="margin-top: 10px;">Cell Phone</label> -->
          <input type="text" class="form-control mt-1" v-model="field5" placeholder="City">
          <!-- <label style="margin-top: 10px;">Child's Doctor</label> -->
          <input type="text" class="form-control mt-1" v-model="field6" placeholder="State">
          <!-- <label style="margin-top: 10px;">Doctor's Phone</label> -->
          <input type="text" class="form-control mt-1" v-model="field7" placeholder="Zip Code">
          <label style="">Are you legally able to work in the US?*</label>
          <input type="text" class="form-control" v-model="field8">
          <label style="">Social Security Number (SSN)*</label>
          <input type="text" class="form-control" v-model="field9">
        </div>
      </div>
      <div v-if="document.status == 'Signed'">
        <!-- <p>{{ document }}</p> -->
        <p>Name: {{ document.field1 }}</p>
        <p>Date of Birth: {{ document.field2 }}</p>
        <p style="margin-bottom: 0;">Address:</p>
        <p style="margin-bottom: 0;">{{ document.field3 }}</p>
        <p style="margin-bottom: 0;">{{ document.field4 }}</p>
        <p style="margin-bottom: 0;">City: {{ document.field5 }}</p>
        <p style="margin-bottom: 0;">State: {{ document.field6 }}</p>
        <p>Zip Code: {{ document.field7 }}</p>
        <p>Legally able to work in the US: {{ document.field8 }}</p>
        <p>Social Security Number (SSN): {{ document.field9 }}</p>
      </div>
      <hr>
      <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
      <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
      <h4 v-if="signature" style="font-family: 'Arizonia'; text-transform: none;">{{ signature }}</h4>
      <h4 v-if="!signature">___________________</h4>
      <p v-if="document.status == 'Signed'">{{ document.signing_name }}</p>
      <div v-if="!document.signing_name">
        <input type="text" class="form-control" v-model="signature" style="max-width: 500px;">
        <label v-if="!signature" class="mt-1">Please type your name.</label>
        <div>
          <button v-if="!signature" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
          <button v-if="signature && field1 && field2 && field3 && field5 && field6 && field7 && field8 && field9" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
        </div>
      </div>
      <!-- <p>{{ document }}</p> -->
      <!-- <button @click="deleteDocument()" class="mylisting-button danger-button">Delete</button> -->
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['document'],
  data() {
    return {
      field1: '',
      field2: '',
      field3: '',
      field4: '',
      field5: '',
      field6: '',
      field7: '',
      field8: '',
      field9: '',
      signature: '',
    }
  },
  created() {
    this.field1 = this.document.field1
    this.field2 = this.document.field2
    this.field3 = this.document.field3
    this.field4 = this.document.field4
    this.field5 = this.document.field5
    this.field6 = this.document.field6
    this.field7 = this.document.field7
    this.field8 = this.document.field8
    this.field9 = this.document.field9
    this.signature = this.document.signing_name
  },
  methods: {
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        field1: this.field1,
        field2: this.field2,
        field3: this.field3,
        field4: this.field4,
        field5: this.field5,
        field6: this.field6,
        field7: this.field7,
        field8: this.field8,
        field9: this.field9,
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteDocument() {
      axios.delete(`/api/documents/${this.document.id}/`)
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/candidates/documents/BackgroundCheck.vue